<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div class="snackbar">
  <div>{{ data.text }}</div>
  <div>
    <rx-icon (click)="dismiss()" name="close" class="white"></rx-icon>
    <div *ngIf="data.dismissText" class="dismiss-text" (click)="dismiss()">{{ data.dismissText }}</div>
  </div>
</div>
<div>
  <mat-progress-bar
    *ngIf="data?.progress?.show"
    style="margin-top: 5px"
    [value]="data.progress.perc"
  ></mat-progress-bar>
</div>
